import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";
import { WebsitesItem } from "../../store/websites/types";

type GetJwtTokenAsync = (payload: {
  accessToken: string;
  websiteId: number;
  subdomain: string;
}) => Promise<AxiosResponse<any>>;

export const getJwtTokenAsync: GetJwtTokenAsync = ({
  accessToken,
  websiteId,
  subdomain,
}) => {
  return new Promise((resolve, reject) => {
    const apiUrl = `${api.meta.getJwtToken}?website_id=${websiteId}&subdomain=${subdomain}`;
    axios
      .get(apiUrl, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
